import { InteractiveCheckboxProps } from "../types/PriceTabTypes";

export const InteractiveCheckbox: React.FC<InteractiveCheckboxProps> = ({
  checked,
  onChange,
  disabled = false,
  title
}) => (
  <div className="text-center">
    <div
      className={`form-check form-switch d-inline-block ${disabled ? 'opacity-50' : ''}`}
      style={{ cursor: disabled ? 'not-allowed' : 'pointer' }}
    >
      <input
        className="form-check-input"
        type="checkbox"
        checked={checked}
        onChange={(e) => !disabled && onChange(e.target.checked)}
        disabled={disabled}
        title={title}
        style={{ cursor: disabled ? 'not-allowed' : 'pointer' }}
      />
    </div>
  </div>
);